module.exports = __webpack_public_path__ + "img/grid-fill.39b646ba.svg";